module.exports = __webpack_public_path__ + "883bca42a5589ea01f3c3fec097711a4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/menu.svg
// module id = 765
// module chunks = 0